<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div style="margin-bottom: 18px">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称" style="width: 232px" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品编号" prop="goodsNo">
            <el-input v-model="searchForm.goodsNo" placeholder="请输入商品编号" style="width: 232px"></el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="remark">
            <el-input v-model="searchForm.remark" placeholder="请输入备注信息" style="width: 232px"></el-input>
          </el-form-item>
          <el-form-item label="商品类目" prop="categoryIds">

            <el-cascader style="width: 232px" :options="categoryIds" v-model="searchForm.categoryIds" class="contentS"
              :show-all-levels="false" :props="{ checkStrictly: true, multiple: true, emitPath: false }"
              @change="onChangeCategory" collapse-tags clearable filterable size="small"></el-cascader>
          </el-form-item>
          <el-form-item label="上次编辑" prop="createdTimeStart">
            <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="创建时间" prop="createdTimeStart">
            <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="绑定SKU" prop="sku">
            <el-input v-model="searchForm.sku" placeholder="请输入SKU编号" style="width: 232px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3 style="font-weight: bold">
        列表数据
        <!-- <span style="color: #f63c56; font-size: 14px; margin-left: 12px">剩余可上架数量（{{ surNum }}）</span> -->
      </h3>
      <div class="btn-list">
        <div class="item">
          <el-radio-group v-model="radio1" @change="selectData">
            <el-radio-button label=" " border>全部({{
              countGroupByStatus.total
            }})</el-radio-button>
            <el-radio-button label="1">已上架({{ countGroupByStatus.allShelvesCount }})</el-radio-button>
            <el-radio-button label="0">已下架({{
              countGroupByStatus.allUnShelvesCount
            }})</el-radio-button>
          </el-radio-group>
        </div>
        <div class="item">
          <!-- <el-button type="warning" style="width: 92px" @click="toApply()" :disabled="currentStatus === groupByStatus.onSaleCount ? true : false
              ">商品审核</el-button>
          <el-button type="warning" style="width: 106px" @click="toAwait()" :disabled="currentStatus === groupByStatus.offSaleCount ? true : false
            ">待上架商品</el-button> -->
          <div style="display: flex;">
            <div class="u-btn" @click="pUp('1')">批量上架</div>
            <div class="u-btn" @click="pUp('0')">批量下架</div>
            <div class="u-btn1" @click="toLink">弹窗跳转设置</div>
            <el-button type="primary" @click="add" icon="el-icon-plus">添加商品</el-button>
            <el-button type="primary" @click="exportData()" icon="el-icon-upload2">批量导出</el-button>
          </div>


        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="删除提示" :visible.sync="isD" width="518px" :append-to-body="true" custom-class="infoI">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: red; font-size: 20px"></i>删除后不可恢复数据，是否继续？
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isD = false">取消</div>
          <div class="info-s" @click="deleteShop">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isLimit" width="518px" :append-to-body="true">
      <template>
        <div class="info">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>您已新增上架商品
          {{ numberY }}
          个，已达新增上架商品上限，若想继续新增商品，请下架其中一个商品；
        </div>
        <div class="info-b">
          <span style="color: red">*</span> 若增加上架个数，请联系客服！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isLimit = false">取消</div>
          <div class="info-s" @click="sLimit()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isSup" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>当前商品已上架第三方平台，是否确认下架？
        </div>
        <div class="info-b">下架后所有平台都下架该商品！</div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isSup = false">取消</div>
          <div class="info-s" @click="sUpData">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isS" width="518px" :append-to-body="true" custom-class="infoI">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: red; font-size: 20px"></i>{{ tName }}
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isS = false">取消</div>
          <div class="info-s" @click="batchUp">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog :title="titleU" :visible.sync="isU" width="518px" :append-to-body="true" custom-class="infoI">
      <template>
        <div>
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>{{ contentU }}
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isU = false">取消</div>
          <div class="info-s" @click="updateUp">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="查看绑定SKU" :visible.sync="isSku" width="40%" :append-to-body="true">
      <template>
        <div>

          <div>
            <lb-table v-horizontal-scroll="'always'" :column="columnsT" :data="skus">
            </lb-table>
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 24px">
        </div>
      </template>
    </el-dialog>
    <el-dialog title="广告链接设置" :visible.sync="isLink" width="1050px" :append-to-body="true" custom-class="link"
      :close-on-click-modal="false">
      <template>
        <div style="display: flex;justify-content: space-between;">
          <div class="c-link" @click="createLink('add')">创建链接</div>
          <el-tooltip popper-class="atooltip-c" effect="dark" placement="bottom-end" :visible-arrow="false"
            :hide-after="0">
            <div class="t-flow">选择投流小程序</div>
            <div slot="content">
              <div class="f-title">已绑定小程序</div>
              <div v-for="(item, index) in flows" :key="index" class="f-item">
                <div class="name">{{ item.name }}</div>
                <div class="ido">原始ID:{{ item.originId }}<img src="../../../assets/icon_fuzhi@2x.png"
                    @click="copyI(item.originId)" style="width:14px;height:14px;margin-left: 8px;margin-top: 4px;" />
                </div>
                <div class="id">AppID:{{ item.appid }}<img src="../../../assets/icon_fuzhi@2x.png"
                    @click="copyI(item.appid)" style="width:14px;height:14px;margin-left: 8px;margin-top: 4px;" /></div>
              </div>
            </div>
          </el-tooltip>
          <!-- <div class="t-flow" @click="createLink">选择投流小程序</div> -->
        </div>
        <div style="display: flex;justify-content: space-between;margin-top:18px">
          <div><el-input v-model="lForm.name" placeholder="请输入链接名称" style="width: 232px;" @change="selectL"></el-input>
          </div>
          <div><el-input v-model="lForm.account" placeholder="搜索广告账户" style="width: 232px;" @change="selectL"></el-input>
          </div>
          <div> <el-select style="width: 232px" v-model="lForm.ad" placeholder="选择广告渠道" filterable clearable
              @change="selectL">
              <!-- <el-option label="全部广告渠道" value="0"></el-option> -->
              <el-option label="腾讯广告" value="1"></el-option>
            </el-select></div>
          <div> <el-select style="width: 232px" v-model="lForm.payType" placeholder="选择支付方式" filterable clearable
              @change="selectL">
              <el-option label="全部支付方式" value="0"></el-option>
              <el-option label="微信支付" value="1"></el-option>
            </el-select></div>
        </div>
        <el-table :data="links" :header-cell-style="{ background: '#fafafa', color: '#333333' }"
          style="margin-top: 18px;">
          <el-table-column label="广告投放链接" headerAlign="left" width="460px">
            <template slot-scope="props">
              <div style="text-align: left">
                <div>
                  <span>{{
                    props.row.name ? props.row.name : "--"
                  }}</span>
                </div>
                <p class="accountId">广告账户ID:{{ props.row.adAccountId || '--' }}</p>
                <div style="display:flex;flex-wrap: wrap;">
                  <div class="accountId">
                    广告链接ID:{{
                      props.row.id ? props.row.id : "--"
                    }}
                    <!-- <img src="../../../assets/icon_fuzhi@2x.png"
                      style="width:14px;height:14px;margin-left: 8px;margin-top: 4px;" />
                    <span style="color: #2D46EE;margin-left:4px">复制</span> -->
                  </div>
                </div>
                <div style="display:flex;flex-wrap: wrap;">
                  <div class="accountId">
                    <div>{{ props.row.url }}</div>
                    <img src="../../../assets/icon_fuzhi@2x.png"
                      style="width:14px;height:14px;margin-left: 8px;margin-top: 4px;cursor:pointer"
                      @click="copyI(props.row.url)" />
                    <span style="color: #2D46EE;margin-left:4px;cursor:pointer" @click="copyI(props.row.url)">复制</span>
                  </div>
                </div>
                <div style="display: flex;margin-top: 11px;">
                  <div class="ld">图文落地页</div>
                  <div class="ad" style="margin-left: 8px;margin-right: 8px;">腾讯广告</div>
                  <div class="ad">微信支付</div>
                </div>



              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="props">
              <div>
                {{ props.row.createdTime || '--' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="券后订单回传">
            <template slot="header">
              <div style="display: flex;">
                <div>券后订单回传</div>
                <el-tooltip effect="dark" content="开启后,回流订单将回传至广告侧，支持设置回传比例（实时回传中可能存在较小的误差）" placement="top">
                  <img src="../../../assets/icon/icon_qipao.png"
                    style="width: 18px; height: 18px; margin-left: 4px;margin-top:2px" />
                </el-tooltip>
              </div>

            </template>
            <template slot-scope="props">
              <div><el-switch active-text="是" inactive-text="否" v-model=props.row.statusL active-color="#2D46EE" disabled
                  inactive-color="#EBEEFA">
                </el-switch></div>
              <div style="margin-top:6px">回传100%</div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100px">
            <template slot-scope="props">
              <div>
                <el-popover placement="right-start" width="186" trigger="click" popper-class="atooltip-y">
                  <div>
                    <div class="a-title">落地页预览</div>
                    <img :src="img" style="width:128px;height: 128px;margin-left: 29px;" />
                    <div class="a-info">手机微信扫码预览</div>
                  </div>

                  <div slot="reference" style="color: #2D46EE;width:30px;cursor:pointer"
                    @click="preView(props.row, props.$index)">预览
                  </div>
                </el-popover>
                <!-- <div style="color: #2D46EE">预览</div> -->
                <!-- <el-tooltip popper-class="atooltip-y" effect="dark" placement="right-start" :visible-arrow="false"
                  :manual="true" :value="props.row.isP" :hide-after="0">
                  <div style="color: #2D46EE;width:30px;cursor:pointer" @click="preView(props.row.id, props.$index)">预览
                  </div>
                  <div slot="content">
                    <div class="a-title">落地页预览</div>
                    <img :src="props.row.img" style="width:128px;height: 128px;margin-left: 29px;" />
                    <div class="a-info">手机微信扫码预览</div>
                  </div>
                </el-tooltip> -->
              </div>
              <div style="color: #2D46EE;cursor:pointer" @click="createLink('edit', props.row)">修改</div>
              <div style="color: #2D46EE;cursor:pointer" @click="deteleL(props.row.id)">删除</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="b-pagination">
          <el-pagination @size-change="handleSizeChangeL" @current-change="handleCurrentChangeL"
            :current-page="lForm.pageNo" :page-sizes="[5, 10, 20, 50]" :page-size="lForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="lForm.total">
          </el-pagination>
        </div>

      </template>
    </el-dialog>


    <el-drawer :title="drawerTitle" :visible.sync="drawer" :size="643" :append-to-body="true">
      <div class="d-content">
        <div class="d-content-info">链接支持创建一个营销页，用户从广告页面划走后默认进入该营销页，进行二次回流转化。支持自定义上传素材，如未自定义则默认</div>
        <div style="margin-top: 18px;margin-left: 32px;margin-right: 10px;">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" size="small" class="ruleForm">
            <el-form-item label="链接名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="仅作为内部标记使用" style="width:348px"></el-input>
            </el-form-item>
            <el-form-item label="关联广告账户" prop="adAccountId">
              <el-select style="width: 232px" v-model="ruleForm.adAccountId" placeholder="请选择广告渠道" filterable clearable>
                <!-- <el-option label="全部广告渠道" value="0"></el-option> -->
                <el-option label="腾讯广告" value="1"></el-option>
              </el-select>
              <el-input style="width: 232px;margin-left: 12px;" v-model="ruleForm.account"
                placeholder="输入广告账户ID(可选填)"></el-input>
            </el-form-item>
            <el-form-item label="落地页类型" prop="ld">
              <el-radio v-model="ruleForm.ld" label="1">图文落地页</el-radio>
            </el-form-item>
            <el-form-item label="支付方式" prop="payType1">
              <div style="display: flex;">
                <div><el-checkbox v-model="ruleForm.payType1">微信支付</el-checkbox></div>
                <div class="m-info">默认</div>
              </div>
            </el-form-item>
            <el-form-item label="营销页设置" prop="marketing" style="font-size: 18px;">
              <div style="display: flex;align-items: center;">
                <el-switch v-model="ruleForm.marketing" active-color="#2D46EE"></el-switch>
                <span style="font-size: 12px;margin-left: 10px;">打开可设置营销页，及优惠金额设置，建议开启</span>
              </div>
            </el-form-item>
            <template v-if="ruleForm.marketing">
              <el-form-item label="页面类型" prop="ld">
                <el-radio v-model="ruleForm.ld" label="1">单品页</el-radio>
              </el-form-item>
              <el-form-item label="挽回优惠" prop="couponId">
                <!-- <el-input v-model="ruleForm.price" placeholder="请输入优惠金额" style="width:348px"></el-input> -->
                <el-select v-model="ruleForm.couponId" placeholder="请选择优惠券" filterable clearable style="width: 232px">
                  <el-option v-for="(item, index) in couponList" :key="index" :label="item.name" :value="item.id">{{
                    item.name }}</el-option>
                </el-select>
              </el-form-item>
              <!-- <div class="p-info">用户退出商品时，提示优惠的金额可领取；(设置金额不可大于该商品规格最低的零售价)</div> -->
              <el-form-item label="营销页弹窗" prop="popImg">
                <upload-picture :imageUrl="ruleForm.popImg" :width="'108px'" :height="'108px'"
                  @getUrl="getImage($event, 'popImg')"></upload-picture>
              </el-form-item>
              <div class="p-info">营销页弹窗在用户从广告商品详情划走后显示;<br /> 尺寸建议上传320*232px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;</div>
              <el-form-item label="页面banner" prop="banner">
                <upload-picture :imageUrl="ruleForm.banner" :width="'108px'" :height="'108px'"
                  @getUrl="getImage($event, 'banner')"></upload-picture>
              </el-form-item>
              <div class="p-info">营销页顶部banner；（不上传则使用默认banner提示<span style="color: #2D46EE;cursor:pointer"
                  @click="lookY">查看样式</span>）<br />尺寸建议宽度750px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;</div>
              <el-form-item label="上传商品图" prop="goodsImg">
                <upload-picture :imageUrl="ruleForm.goodsImg" :width="'108px'" :height="'108px'"
                  @getUrl="getImage($event, 'goodsImg')"></upload-picture>
              </el-form-item>
              <div class="p-info">营请上传广告品对应的商品图；<span style="color: #2D46EE;cursor:pointer"
                  @click="lookY">查看样式</span><br />
                尺寸建议跨度750px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;</div>
              <el-form-item label="底部banner" prop="underBanner">
                <upload-picture :imageUrl="ruleForm.underBanner" :width="'108px'" :height="'108px'"
                  @getUrl="getImage($event, 'underBanner')"></upload-picture>
              </el-form-item>
              <div class="p-info">营销页底部banner；（不上传则使用默认banner提示<span style="color: #2D46EE;cursor:pointer"
                  @click="lookY">查看样式</span>）<br />尺寸建议宽度750px，每张上传大小不得超过2M,支持jpg、jpeg、png、gif格式;</div>
            </template>
          </el-form>
        </div>
      </div>
      <div class="d-bottom">
        <div style="display: flex; justify-content: start;padding-top:24px;padding-left:24px">
          <div class="info-q" @click="drawer = false">取消</div>
          <div class="info-s" @click="submitDrawer">确定</div>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="查看样式" :visible.sync="isLook" width="635px" :append-to-body="true">
      <template>
        <div style="display:flex">
          <div class="phone-v">
            <div v-if="banner1"><img :src="banner1" style="width:375px;height:186px;margin-top:119px;margin-left:1px" />
            </div>
            <!-- <div style="width:375px;height:186px;margin-top:119px;margin-left:1px"></div> -->
            <div v-if="ruleForm.goodsImg"><img :src="ruleForm.goodsImg"
                style="width:375px;height:233px;margin-left:1px;margin-top:-5px" />
            </div>
            <div v-else style="width:375px;height:233px;margin-left:1px;"></div>
            <div v-if="underBanner1"><img :src="underBanner1"
                style="width:375px;height:130px;margin-left:1px;margin-top:-5px;border-bottom-left-radius:16px;border-bottom-right-radius:16px;" />
            </div>
            <!-- <div v-else
              style="width:375px;height:130px;margin-left:1px;margin-top:-5px;border-bottom-left-radius:16px;border-bottom-right-radius:16px;">
            </div> -->
          </div>
          <div style="display:flex;flex-direction:column;justify-content:space-between">
            <div style="height:119px"></div>
            <div style="display:flex;height:186px;flex-direction:column;justify-content:center">
              <div style="display:flex">
                <div class="line"></div>
                <div class="line-r"></div>
                <div class="r-title">页面banner</div>
              </div>

            </div>
            <div style="display:flex;height:233px;flex-direction:column;justify-content:center">
              <div style="display:flex">
                <div class="line"></div>
                <div class="line-r"></div>
                <div class="r-title">商品图</div>
              </div>
            </div>
            <div style="display:flex;height:130px;flex-direction:column;justify-content:center">
              <div style="display:flex">
                <div class="line"></div>
                <div class="line-r"></div>
                <div class="r-title">底部banner</div>
              </div>
            </div>
          </div>
        </div>


      </template>
    </el-dialog>
    <el-dialog title="跳转第三方小程序" :visible.sync="isT" width="487px" :append-to-body="true">
      <template>
        <el-form :model="returnForm" :rules="rules" ref="returnForm" label-width="110px" size="small" class="ruleForm">
          <el-form-item label="返回弹窗" prop="returnImg">
            <upload-picture :imageUrl="returnForm.returnImg" :width="'108px'" :height="'108px'"
              @getUrl="getImage1($event, 'returnImg')"></upload-picture>
          </el-form-item>
          <div class="p-info">建议JPG、JPEG、PNG格式，大小500*600px，5M以内</div>
          <el-form-item label="返回跳转链接" prop="returnUrl">
            <el-input v-model="returnForm.returnUrl" placeholder="请输入链接" style="width:331px"></el-input>
          </el-form-item>
          <el-form-item label="支付弹窗" prop="paySuccessImg">
            <upload-picture :imageUrl="returnForm.paySuccessImg" :width="'108px'" :height="'108px'"
              @getUrl="getImage1($event, 'paySuccessImg')"></upload-picture>
          </el-form-item>
          <div class="p-info">建议JPG、JPEG、PNG格式，大小500*600px，5M以内</div>
          <el-form-item label="支付跳转链接" prop="paySuccessUrl">
            <el-input v-model="returnForm.paySuccessUrl" placeholder="请输入链接" style="width:331px"></el-input>
          </el-form-item>

        </el-form>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isT = false">取消</div>
          <div class="info-s" @click="settingT">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script >
import LbTable from '../../../components/lb-table/lb-table'
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import Label from '../components/label.vue'
import ModifyState from '../components/ModifyState.vue'
import mixinsGiftlist from '../mixins/mixinsGiftlist.js'
import uploadPicture from '@/components/upload/mallPicture1.vue'
import QRCode from 'qrcodejs2'
export default {
  mixins: [mixinsGiftlist],
  components: {
    Label,
    LbTable,
    breadcrumbTop,
    ModifyState,
    breadcrumbSearch,
    uploadPicture
    // BaseList
  },
  data() {
    return {
      returnForm: {
        returnImg: '',
        returnUrl: '',
        paySuccessImg: '',
        paySuccessUrl: ''
      },
      isT: false,
      banner1: require('../../../assets/banner_head.png'),
      underBanner1: require('../../../assets/banner_tail.png'),
      img: '',
      disA: true,
      isLook: false,
      ruleForm: {
        goodsId: '',
        id: '',
        name: '',
        account: '',
        adAccountId: '',
        ld: '1',
        payType1: true,
        payType: '1',
        price: '',
        popImg: '',
        banner: '',
        goodsImg: '',
        underBanner: '',
        marketing: false,
        couponId: ''
      },
      couponList: [],
      rules: {
        adAccountId: [
          { required: true, message: '请选择广告渠道', trigger: 'change' }
        ],
        payType1: [
          {
            required: true, message: '请选择支付方式', trigger: 'change'
          }
        ],
        couponId: [
          { required: true, message: '请选择优惠', trigger: 'change' }
        ],
        popImg: [
          { required: true, message: '请上传营销页', trigger: 'change' }
        ],
        goodsImg: [
          { required: true, message: '请上传商品图', trigger: 'change' }
        ],
      },
      drawerTitle: '创建广告链接',
      flows: [

      ],
      links: [

      ],
      lForm: {
        name: '',
        account: '',
        ad: '',
        payType: '',
        pageNo: 1,
        pageSize: 5,
        total: 0
      },
      drawer: false,
      isLink: false,
      tName: '所选商品是否全部上架？',
      isSku: false,
      isS: false,
      isD: false,
      pageNo: 1,
      pageSize: 10,
      tagList: [],
      totalNum: 0,
      name: '',
      isTag: false,
      isSdown: false,
      isSup: false,
      isLimit: false,
      radio1: ' ',
      isUp: 'up',
      searchList: {
        list: [
          { title: '商品列表', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      shopLists: [

      ],
      title: '批量上架',
      isShow: false,
      GoodsExportLoading: false,
      goods_types: [
        {
          dictId: '1',
          dictName: '普通商品'
        },
        {
          dictId: '3',
          dictName: '赠品'
        }
      ],
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品列表', path: '', type: '1' }
        ]
      },
      value1: [],
      value2: [],
      searchForm: {
        name: '', // 	否 	string 	商品名称

        categoryIds: [], // 	否 	int 	类目id（数据来源：接口 - /order/comm/commodityCategory/commList）

        applyEndTime: '',
        applyStartTime: '',
        pageNo: 1,
        pageSize: 10,
        goodsNo: '',
        sku: "",
        remark: '',
        createdTimeEnd: '',
        createdTimeStart: ''
      },
      tags: [],
      currentStatus: 100, // 当前列表状态
      groupByStatus: { // 数据切换
        totalCount: 100, // 全部
        onSaleCount: 200, // 上架中商品
        offSaleCount: 300 // 已下架商品
      },
      countGroupByStatus: { // 商品列表数量统计
        allShelvesCount: 0,
        allUnShelvesCount: 0,
        total: 0
      },
      // 数据列表
      list: [],
      loading: false,
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      originList: [
        {
          id: 1,
          name: '平台上架'
        },
        {
          id: 2,
          name: '五域上架'
        },
      ],//来源列表
      categoryIds: [],
      columnsT: [
        { label: 'SKU编码', prop: 'sku', minWidth: '120', align: 'center' },
        {
          label: '规格', prop: 'spec', minWidth: '140', align: 'center'
        },
        { label: '零售价', prop: 'retailPrice', minWidth: '120', align: 'center' },
        {
          label: '库存', prop: 'stock', minWidth: '140', align: 'center'
        },
        { label: '绑定的SKU编码', prop: 'bindSku', minWidth: '120', align: 'center' },


      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },

        {
          label: '商品信息',
          width: '300',
          render: (h, scope) => {
            return (
              <div style="display:flex;">
                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                <div style="text-align:left;flex:1;">
                  <div style="width:100%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;">
                    {scope.row.name}
                  </div>
                  <p>商品编号：{scope.row.goodsNo}</p>
                </div>
              </div>
            )
          }
        },
        {
          label: '备注信息', prop: 'remark', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                {scope.row.remark || '--'}
              </div>
            )
          }
        },
        { label: '商品类目', prop: 'categoryName', minWidth: '120' },
        {
          label: '价格', prop: 'price', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                {scope.row.priceMin}~{scope.row.priceMax}
              </div>
            )
          }
        },
        { label: '库存', prop: 'stock', minWidth: '90' },
        {
          label: '累计销量', prop: 'soldNum', minWidth: '90',
          renderHeader: (h, scope) => {
            return (
              <div>
                <span>累计销量</span> <el-tooltip class="item" effect="dark" content="不包含虚拟销量" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>
                {scope.row.soldNum}
              </div>
            )
          }
        },
        {
          label: '绑定SKU', prop: 'createdTime', width: '170',
          render: (h, scope) => {
            if (!scope.row.bindSkuList1) return
            return (
              <div>
                {
                  scope.row.bindSkuList1.map(item => {
                    return (
                      <p style="display:flex;flex-direction:column">{item}</p>
                    )
                  })
                }
              </div>
            )
          }
        },
        {
          label: '上次编辑/创建时间', prop: 'createdTime', width: '170',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.updatedTime}</p>
                <p>{scope.row.createdTime}</p>
              </div>
            )
          }
        },

        {
          label: '是否上架',
          minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <el-switch
                  onChange={() => { this.isUpShop(scope.row, scope.$index) }}
                  active-text="是"
                  inactive-text="否"
                  v-model={scope.row.statusL}
                  active-color="#2D46EE"
                  inactive-color="#EBEEFA">
                </el-switch>
                {/* <p class={scope.row.status === 1 ? 'success' : 'danger'}>{scope.row.statusLabel}</p> */}
              </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '160',

          renderHeader: (h, scope) => {
            return (
              <div>
                <span >操作</span>
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>
                <el-dropdown onCommand={($event) => { this.handleCommand($event, scope.row) }} placement="bottom">
                  <span class="el-dropdown-link" style="color: #4168e7;cursor: pointer;">
                    更多<i class="el-icon-arrow-down el-icon--right" style="color: #4168e7;cursor: pointer;"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" class="dropdown">
                    <el-dropdown-item command="look" onClick={() => { this.toOtherPages('inflowShopAdd', scope.row, 'edit') }}>查看/编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除商品</el-dropdown-item>
                    <el-dropdown-item command="link">广告链接</el-dropdown-item>
                    <el-dropdown-item command="sku">查看绑定SKU</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      dictionaries: { // 字典数据
        sale_status: [], // 状态
        goods_type: [] // 商品类型
      },
      selectionGoods: [], // 选 中 商品
      parArray: [],// 按钮权限
      numberY: 0,
      surNum: 0,
      cRow: {},
      pageNo: 1,
      pageSize: 10,
      psGoodsIds: [],
      searchFormT: {
        tagName: '',
        status: '',
        createdTimeStart: "",
        createdTimeEnd: '',
        pageNo: 1,
        pageSize: 1000000
      },
      skus: [
        {
          skuNo: '1622555555'
        },
        {
          skuNo: '1622555555'
        },
        {
          skuNo: '1622555555'
        },
        {
          skuNo: '1622555555'
        }
      ],
      gId: '',
      isDs: '1',
      lId: '',
      titleU: '上架提示',
      contentU: '',
      isU: false,
      uId: '',
      uStatus: ''
    }
  },
  mounted() {

  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'inflowShopAdd') {
      next(vm => {
        vm.fetchData();
      });
    } else {
      next(vm => {
        vm.fetchData();
      });
    }
  },
  created() {
    this.getDictionaries('goods_type')
    this.getDictionaries('sale_status')
    this.getCategoryList()
    // this.fetchData()
  },
  methods: {
    settingT() {
      this.axios.post('/inflowGoods/navigate', this.returnForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('设置成功')
            this.isT = false

          }
        })
    },
    toLink() {
      this.isT = true
      this.axios.get('/inflowGoods/navigateGet')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.returnForm = res.data
          }
        })
    },
    deteleL(id) {
      this.isD = true
      this.isDs = '0'
      this.lId = id
    },
    deleteShop() {
      if (this.isDs == 1) {
        this.axios.post('/inflowGoods/delete', { id: this.gId })
          .then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success('删除成功')
              this.isD = false
              this.fetchData()
            }
          })
      } else {
        this.axios.post('/inflowGoods/addelete', { id: this.lId })
          .then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success('删除成功')
              this.isD = false
              this.getLinkList(this.gId)
            }
          })
      }

    },
    copyI(val) {
      const that = this

      that.$copyText(val).then(
        function (e) {
          that.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          that.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    submitDrawer() {
      this.ruleForm.goodsId = this.gId
      // if (this.ruleForm.payType == true) {
      //   this.ruleForm.payType = 1
      // }
      this.ruleForm.payType = 1
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.ruleForm.marketing = this.ruleForm.marketing ? 1 : 0;
          this.axios.post('/inflowGoods/getGoodsAdaddEdit', this.ruleForm)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                this.$message.success('操作成功')

                this.drawer = false
                this.getLinkList(this.gId)
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getImage(val, type) {
      console.log(val)
      if (type == 'popImg') {
        this.ruleForm.popImg = val
      } else if (type == 'banner') {
        this.ruleForm.banner = val
        this.banner1 = val
      } else if (type == 'goodsImg') {
        this.ruleForm.goodsImg = val
      } else if (type == 'underBanner') {
        this.ruleForm.underBanner = val
        this.underBanner1 = val
      }
    },
    getImage1(val, type) {
      console.log(val)
      if (type == 'returnImg') {
        this.returnForm.returnImg = val
      } else if (type == 'paySuccessImg') {
        this.returnForm.paySuccessImg = val

      }
    },
    lookY() {
      this.isLook = true
      if (this.ruleForm.banner == '') {
        this.banner1 = require('../../../assets/banner_head.png')
      }
      if (this.ruleForm.underBanner == '') {
        this.underBanner1 = require('../../../assets/banner_tail.png')
      }
    },
    createLink(type, row) {
      if (type == 'add') {
        this.drawerTitle = '创建广告链接'
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.resetFields()
          }
          this.ruleForm.id = ''
          this.banner1 = ''
          this.underBanner1 = ''
          this.ruleForm.account = ''
        })
        this.ruleForm.adAccountId = ''
        this.getUserInfo()
      } else {
        this.drawerTitle = '编辑广告链接'
        this.$nextTick(() => {
          if (this.$refs.ruleForm) {
            this.$refs.ruleForm.resetFields()
          }
        })
        this.getLinkDetail(row.id)
        this.ruleForm.id = row.id
        this.getUserInfo()
      }
      this.drawer = true
    },
    getUserInfo() {
      this.axios.post('/sys/getUserInfo')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.userInfo = res.data
            let data = {
              goodsId: this.gId,
              platformId: res.data.platformId
            }
            this.axios.post('/inflowGoods/queryCoupon', data)
              .then(res1 => {
                if (res1.code == 0) {
                  this.couponList = res1.data
                }
              })
          }
        })
    },
    // getCouponsList() {
    //   console.log(localStorage.getItem('userInfo'))

    // },
    getLinkDetail(id) {
      let data = {
        id: id
      }
      this.axios.post('/inflowGoods/getGoodsAdgetInfo', data)
        .then(res => {
          if (res.code == 0) {
            this.ruleForm = res.data
            this.ruleForm.ld = '1'
            this.ruleForm.payType1 = true
            this.ruleForm.adAccountId = String(this.ruleForm.adAccountId)
            this.ruleForm.marketing = res.data.marketing == 1 ? true : false;
            console.log(this.ruleForm)
            this.banner1 = this.ruleForm.banner
            this.underBanner1 = this.ruleForm.underBanner
            this.$forceUpdate()
          }
        })
    },
    batchUp() {
      const selectionId = []
      const selectionGoods = this.selectionGoods
      selectionGoods.forEach(e => { selectionId.push(e.id) })
      let status = 0
      if (this.tName == '所选商品是否全部上架？') {
        status = 1
      } else {
        status = 0
      }
      let data = {
        id: selectionId,
        status: status
      }
      this.axios.post('/inflowGoods/shelvesBatch', data)
        .then(res => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.isS = false
            this.fetchData()
          }
        })
    },
    pUp(val) {
      const selectionId = []
      const selectionGoods = this.selectionGoods
      selectionGoods.forEach(e => { selectionId.push(e.id) })
      if (selectionId.length == 0) {
        this.$message.warning('请选择上架商品')
        return
      }
      if (val == 1) {
        this.isS = true
        this.tName = '所选商品是否全部上架？'
      } else {
        this.isS = true
        this.tName = '所选商品是否全部下架？'
      }
    },
    handleCommand(e, row) {
      console.log(e)
      if (e == 'look') {
        this.toOtherPages('inflowShopAdd', row, 'edit')
      } else if (e == 'delete') {
        this.isD = true
        this.isDs = '1'
        this.gId = row.id
      } else if (e == 'link') {
        this.isLink = true
        this.gId = row.id
        this.lForm.name = ''
        this.lForm.account = ''
        this.lForm.ad = ''
        this.lForm.payType = ''
        this.getLinkList(row.id)
        this.getFlowList()

      } else if (e == 'sku') {
        this.isSku = true
        this.getSkuList(row.id)
      }
    },
    getFlowList() {
      this.axios.post('/miniApp/getList', {})
        .then(res => {
          this.flows = res.data

        })
    },
    handleCurrentChangeL(currentChange) {
      this.lForm.pageNo = currentChange
      this.getLinkList(this.gId)
    },
    handleSizeChangeL(sizeChange) {
      this.lForm.pageSize = sizeChange
      this.getLinkList(this.gId)
    },
    selectL() {
      this.lForm.pageNo = 1
      this.getLinkList(this.gId)
    },
    getLinkList(id) {
      let data = {
        id: id,
        name: this.lForm.name,
        account: this.lForm.account,
        pageNo: this.lForm.pageNo,
        pageSize: this.lForm.pageSize
      }
      this.axios.post('/inflowGoods/getGoodsAdPageList', data)
        .then(res => {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusL = true
            }
            item.isP = false
            item.url = 'minePages/inflowModal/inflowModal?id=' + item.id
          })
          console.log(res.data.list)
          this.links = res.data.list
          this.lForm.total = res.data.totalNum
        })
    },
    preView(row, index) {
      // this.links[index].isP = !this.links[index].isP
      let str = '?id=' + row.id + '&isPreView=1'
      let data = {
        page: 'minePages/inflowModal/inflowModal',
        id: row.id,
        scene: str
      }
      this.axios.post('/miniApp/getMiniQrcode', data).then(res => {
        if (res.code == 0) {
          this.img = 'data:image/png;base64,' + res.data
          // console.log(this.links[index].img)
        }
      })
      this.$forceUpdate()
      // this.$nextTick(() => {

      // })
    },
    getSkuList(id) {
      let data = {
        id: id
      }
      this.axios.post('/inflowGoods/bindSkus', data)
        .then(res => {
          console.log(res)
          res.data.forEach(item => {
            item.retailPrice = Number(item.retailPrice).toFixed(2)
          })
          this.skus = res.data
        })
    },
    upTags() {
      this.isTag = false
      this.fetchData()
    },
    isUpTag(row) {
      console.log(row)
      let status = 0
      if (row.checked == 0) {
        status = 1
      } else {
        status = 0
      }
      let data = {
        id: row.id,
        status: status,
        psGoodsIds: this.psGoodsIds
      }
      this.axios.post('/psTag/updatePsTag', data).then(res => {
        if (res.code == 0) {
          this.$message.success('更改成功')
        }
      })
    },
    //修改标签
    editTag(val) {
      this.name = ''
      this.psGoodsIds = []
      // this.selectionGoods = []
      this.psGoodsIds = []
      this.pageNo = 1
      this.isTag = true
      // this.selectionGoods.push(val)
      this.psGoodsIds.push(val.id)
      // console.log(this.selectionGoods)
      // this.getTags()
      let data = {
        psGoodsIds: this.psGoodsIds,
        name: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/psTag/tagePageList', data).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '启用'
            } else {
              item.statusLabel = '禁用'
            }
            if (item.checked == 0) {
              item.checkedL = false
            } else {
              item.checkedL = true
            }
          })
          this.tagList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    //批量修改标签
    toEditTag() {
      this.name = ''
      if (this.selectionGoods.length == 0) {
        this.$message.warning('请选择商品')
        return
      } else {
        this.isTag = true
        console.log(this.selectionGoods)
        this.getTags()
      }
    },
    fetchData1(val) {
      if (val == 'reset') {
        this.pageNo = 1
        this.name = ''
      } else if (val == 'search') {
        this.pageNo = 1

      }

      this.getTags1()
    },
    getTags1() {
      // this.psGoodsIds = []
      // this.selectionGoods.forEach(item => {
      //   this.psGoodsIds.push(item.id)
      // })
      let data = {
        psGoodsIds: this.psGoodsIds,
        name: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/psTag/tagePageList', data).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '启用'
            } else {
              item.statusLabel = '禁用'
            }
            if (item.checked == 0) {
              item.checkedL = false
            } else {
              item.checkedL = true
            }
          })
          this.tagList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    getTags() {
      this.psGoodsIds = []
      this.selectionGoods.forEach(item => {
        this.psGoodsIds.push(item.id)
      })
      let data = {
        psGoodsIds: this.psGoodsIds,
        name: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/psTag/tagePageList', data).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '启用'
            } else {
              item.statusLabel = '禁用'
            }
            if (item.checked == 0) {
              item.checkedL = false
            } else {
              item.checkedL = true
            }
          })
          this.tagList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    sLimit() {
      this.isLimit = false
      this.fetchData()
    },
    getPlatformInfo() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          if (this.surNum == 0) {
            this.numberY = res.data.productCount
          }
        }
      })
    },
    sUpData() {
      let data = {
        id: this.cRow.id,
        type: 0
      }
      this.axios.post('/goods/upPsGoods', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isSup = false
          this.fetchData()
        }
      })
    },
    updateUp() {
      let data = {
        id: this.uId,
        status: this.uStatus
      }
      this.axios.post('/inflowGoods/shelves', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isU = false
          this.fetchData()
        } else {
          this.fetchData()
        }
      })
    },
    isUpShop(row, index) {
      let status = 0
      console.log(row)
      this.uId = row.id
      this.isU = true

      if (row.status == 1) {
        this.uStatus = 0
        this.titleU = '下架提示'
        this.contentU = '当前商品已上架，是否确认下架？'
        this.list[index].statusL = true
      } else {
        this.uStatus = 1
        this.titleU = '上架提示'
        this.contentU = '当前商品已下架，是否确认上架？'
        this.list[index].statusL = false
      }
      // let data = {
      //   id: row.id,
      //   status: status
      // }
      // this.axios.post('/inflowGoods/shelves', data).then(res => {
      //   if (res.code == 0) {
      //     this.$message.success('操作成功')
      //     this.fetchData()
      //   } else {
      //     this.fetchData()
      //   }
      // })
    },
    getPlatform() {
      // this.axios.get('/sys/platformInfo', {}).then(res => {
      //   if (res.code == 0) {
      //     this.surNum = res.data.platformInfo.maxGoodsNum - res.data.productCount
      //   }
      // })
    },
    toApply() {
      this.$router.push({
        name: 'shopApply',
        query: {}
      })
    },
    toAwait() {
      this.$router.push({
        name: 'pendingShop',
        query: {}
      })
    },
    exportData() {
      let params = {

      }
      params = Object.assign(params, this.searchForm)
      this.axios.post('/inflowGoods/goodsExportList', params).then((res) => {
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
        console.log(err)
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    selectData() {
      if (this.radio1 == ' ') {
        this.searchForm.status = ''
        // this.radio1 = ''
      } else {
        this.searchForm.status = this.radio1
      }

      this.fetchData()
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    add() {
      this.$router.push({
        name: 'inflowAddShopCategory',
        query: {}
      })
      // this.axios.get('/sys/platformInfo', {}).then(res => {
      //   if (res.code == 0) {
      //     if (this.surNum == 0) {
      //       this.isLimit = true
      //       this.numberY = res.data.productCount
      //     } else {
      //       this.isLimit = false
      //       this.$router.push({
      //         name: 'inflowAddShopCategory',
      //         query: {}
      //       })
      //     }
      //   }
      // })
      // this.$router.push({
      //   name: 'addGoodsCategory',
      //   query: {}
      // })
    },
    changeUp(val) {
      this.isUp = val
    },
    //表格合并行和列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.shopLists.length
      for (let i = 0; i < len; i++) {
        const item = this.shopLists[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.skuNo === this.shopLists[i - 1].skuNo) {
            item.$rows = 0
            this.shopLists[pos].$rows = this.shopLists[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    getretailPrice(title, row) {
      this.dialog.visible = true
      if (title == 'retailPrice') {
        this.dialog.title = '零售价'
      } else if (title == 'stock') {
        this.dialog.title = '可用库存'
      } else {
        this.dialog.title = '销量'
      }
      this.dialog.width = '640px'
      this.dialog.type = title
      this.dialog.list = row.skuList
    },
    fetchData(type) {
      this.loading = true;
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.applyStartTime = this.value1[0];
        this.searchForm.applyEndTime = this.value1[1];
      } else {
        this.searchForm.applyStartTime = ''
        this.searchForm.applyEndTime = ''
      }
      if (this.value2) {
        this.searchForm.createdTimeStart = this.value2[0];
        this.searchForm.createdTimeEnd = this.value2[1];
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      if (type == 'reset') {
        // 
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.searchForm.categoryIds = []
        this.value1 = []
        this.value2 = []
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      console.log(this.searchForm)
      this.axios.post('/inflowGoods/pageList', this.searchForm).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach(e => {
            e.mainImageArr = []
            e.mainImageArr.push(e.mainImage)
            e.statusL = false
            if (e.status == 1) {
              e.statusL = true
            } else {
              e.statusL = false
            }
            // let arr=[]
            e.bindSkuList1 = e.bindSkuList.split(';')
          })

          this.list = res.data.list
          console.log(this.list)
          this.page.totalNum = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
      this.getCountGroupByStatus()// 获取商品列表数量统计
      // this.getPlatform()
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    handleCurrentChange1(currentChange) {
      this.pageNo = currentChange
      this.fetchData1()
    },
    handleSizeChange1(sizeChange) {
      this.pageSize = sizeChange
      this.fetchData1()
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'companyCode'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) { return }
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取商品列表数量统计
    getCountGroupByStatus() {
      const params = {}
      this.axios.post('/inflowGoods/statistics', this.searchForm).then((res) => {
        this.countGroupByStatus = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        categoryName: '',
        categoryNo: '',
        status: null
      }
      this.axios.get('/goods/categoryPageList', {
        params: data

      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.categoryIds = res.data.list
          }
        })
    },
    // 获取 品牌 列表
    getBrandList() {
      const params = { pageNo: 1, pageSize: 999 }
      this.$api.brandCommList(params).then((res) => {
        this.brandList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 切换当前列表
    onChangeList(state) {
      this.page = { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }
      this.currentStatus = state
      // if ( this.currentStatus === this.assignStatus.all) {}
      if (this.currentStatus === this.groupByStatus.totalCount) { this.fetchData('all') }
      if (this.currentStatus === this.groupByStatus.onSaleCount) { this.fetchData('up') }
      if (this.currentStatus === this.groupByStatus.offSaleCount) { this.fetchData('down') }
    },
    // 多选
    onMultipleSelection(val) {
      this.selectionGoods = val
    },
    // 上架、下架
    async operationStatus(type, row) {
      this.isShow = true
      const selectionId = []
      const selectionGoods = this.selectionGoods
      selectionGoods.forEach(e => { selectionId.push(e.id) })
      if (selectionId.length == 0) {
        this.$message.warning('请选择上架商品')
        return
      }
      if (type == 'up') {
        this.title = '批量上架'
      } else {
        this.title = '批量下架'
      }
    },
    onUpDownOperation(type, params, msg) {
      let operationFun
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        switch (type) {
          case 'up':
            operationFun = this.$api.goodsPutOn
            // this.column = columnConsumption
            break
          // 分配记录
          case 'down':
            operationFun = this.$api.goodsPutOff
            break
          // default:
        }
        operationFun(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    showModifyState(skuList, titleArr) {
      // console.log('showModifyState', skuList, titleArr)
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '下架提示'
      this.dialog.width = '640px'
      this.dialog.type = 'modifyState'
      // this.dialog.row = row
      this.dialog.titleArr = titleArr
      // this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 根据商品id,获取礼包列表查询接口
    onGiftListByGoodId(ids) {
      // const params = { goodsIds: ids }
      this.$api.giftListByGoodId(ids).then((res) => {
        console.log(res)
        return res
      }).catch((err) => {
        // console.log(err)
        return res
      })
    },
    // 删除商品
    onGoodsDelete(row) {
      const msg = `此操作将删除【${row.name}】, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '删除商品',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsDelete(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    toOtherPages(name, parameter, type) {
      this.$router.push({
        name,
        query: { id: parameter.id, type, oType: parameter.isMyOutput }
      })
    },
    // 获取 商品 KSU
    getGoodCopySku(skuList, row) {
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '复制SKU码'
      this.dialog.width = '640px'
      this.dialog.type = 'skuList'
      this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 复制 KSU
    onCopySku(info) {
      // console.log('onCopySku', info)
      const t = this
      this.$copyText(info).then(
        function (e) {
          t.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          t.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    // 商品导出
    onGoodsExport() {
      this.GoodsExportLoading = true
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        status: this.currentTab
      }
      params = Object.assign(params, this.searchForm)
      // 类目id
      const tempCategoryIdArr = [].concat(params.categoryId)
      if (tempCategoryIdArr && tempCategoryIdArr.length !== 0) {
        params.categoryId = tempCategoryIdArr[tempCategoryIdArr.length - 1]
      }
      for (const item in params) {
        if (typeof params[item] === 'string') {
          params[item] = params[item].trim()
          if (params[item] === '') { delete params[item] }
        }
      }
      this.$api.goodsExport(params).then((res) => {
        this.GoodsExportLoading = false
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
        console.log(err)
      })
    }
  }
}
</script>
<style  lang="scss">
.u-btn1 {
  width: 92px;
  height: 36px;
  background: #FF9226;
  border-radius: 3px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

/* 改变三角形颜色 */
/* 朝上 */
.atooltip-y[x-placement^="left"] .popper__arrow:after {
  border-left-color: #ffffff;
}

/* 朝下 */
.atooltip-y[x-placement^="right"] .popper__arrow:after {
  border-right-color: #ffffff;
}

/* 改变三角形外边框 */
/* 三角形朝下的时候 */
.atooltip-y[x-placement^="left"] .popper__arrow {
  border-left-color: #ffffff !important;
}

/* 三角形朝上的时候 */
.atooltip-y[x-placement^="right"] .popper__arrow {
  // border-right-color: #ffffff !important;
  display: none !important;
}

/* 自定义内容的区域的颜色 */
.atooltip-y {
  width: 186px;
  height: 206px;
  background: #ffffff !important;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  border: none;
}

.atooltip-c {
  width: 336px;
  height: auto;
  background: #FFFFFF !important;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
}

.el-drawer__header {
  align-items: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;

  color: #303033;
  display: flex;
  margin-bottom: 32px;
  padding: 20px 20px 0;
}

.link {
  .el-dialog__header {
    padding: 24px 24px;
    padding-bottom: 0px;
  }

  .el-dialog__headerbtn {
    margin-right: 10px;
  }

  .el-dialog__body {
    padding: 18px 32px;
    // height: 800px;
    flex: 1;
    overflow: auto;
  }

  .el-input .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}

.infoI {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);

  .el-dialog__body {
    // padding: 30px 25px;
    // height: 800px;
    flex: 1;
    overflow: auto;
  }
}

.b-pagination {
  float: right;
  margin-top: 10px;

  .el-input .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

.el-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: white;
  color: #2D46EE;
}

.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }

  .el-scrollbar:nth-child(2) {
    .el-checkbox {
      display: none;
    }
  }
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
  color: #2d46ee;
  font-weight: 700;
}
</style>

<style scoped lang="scss">
@import "@/assets/styles/modifyState.scss";



::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #2D46EE;
}

.line {
  width: 30px;
  height: 0px;
  border: 1px dashed #F63C56;
  opacity: 1;
  margin-top: 8px
}

.line-r {
  width: 6px;
  height: 6px;
  background: #FFFFFF;
  border: 1px solid #F63C56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 5px;
  margin-right: 4px;
  margin-left: 2px
}

.r-title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 19px;
  color: #303033;
}

.phone-v {
  width: 377px;
  height: 669px;
  background: #fff;
  border-radius: 16px;
  margin-right: 4px;
  position: relative;
  background-image: url(../../../assets/img_iphone.png);
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 90px
}

.d-bottom {
  width: 643px;
  height: 88px;
  background: #FFFFFF;
  box-shadow: 0px -1px 0px #EBEBFA;
  opacity: 1;
  border-radius: 0px 0px 0px 12px;
}

.p-info {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 16px;
  color: #909099;
  margin-left: 110px;
  margin-bottom: 18px
}

.m-info {
  width: 36px;
  height: 18px;
  background: #E9ECFE;
  opacity: 1;
  border-radius: 3px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 18px;
  color: #2D46EE;
  opacity: 1;
  text-align: center;
  margin-left: 4px;
  margin-top: 7px;
}

.d-content {
  // padding: 18px 32px;
  height: calc(100vh - 168px);
  overflow-y: auto;

  .d-content-info {
    width: 571px;
    height: 35px;
    background: #EBEEFA;
    opacity: 1;
    border-radius: 0px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 18px;
    color: #303033;
    padding: 10px 8px;
    margin-left: 32px;
  }
}

.f-item {
  width: 300px;
  height: 89px;
  background: #E9ECFE;
  opacity: 1;
  border-radius: 0px;
  margin-left: 18px;
  margin-bottom: 18px;
  // padding: 10px 12px;

  .name {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #303033;
    margin-left: 12px;
    padding-top: 10px;
  }

  .ido {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #909099;
    margin-left: 12px;
    margin-top: 3px;
    margin-bottom: 3px;
  }

  .id {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #909099;
    margin-left: 12px;
    // margin-top: 6px;
  }
}

.f-title {
  width: 84px;
  height: 19px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  margin-top: 24px;
  margin-left: 18px
}

.a-title {
  width: 70px;
  height: 19px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 19px;
  color: #303033;
  text-align: center;
  margin-left: 58px;
  margin-top: 12px
}

.a-info {
  width: 96px;
  height: 16px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 16px;
  color: #909099;
  opacity: 1;
  margin-left: 45px;
  margin-top: 8px
}

.accountId {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 22px;
  color: #909099;
}

.ld {
  width: 86px;
  height: 24px;
  background: #FFF2E6;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 24px;
  color: #FF9226;
  text-align: center;
}

.ad {
  width: 72px;
  height: 24px;
  background: #E1FAE8;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 24px;
  color: #13CE4B;
  opacity: 1;
  text-align: center;
}

.el-button--primary.is-disabled {
  background: #2D46EE;
  border: 1px solid #2D46EE;
}

.c-link {
  width: 484px;
  height: 36px;
  background: #2D46EE;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.t-flow {
  width: 484px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #2D46EE;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
}

.u-btn {
  width: 92px;
  height: 34px;
  background: #FFFFFF;
  border: 1px solid #2D46EE;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033;
  opacity: 1;
  text-align: center;
}

.info-b {
  margin-left: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 20px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 20px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

.dialog-search {
  margin-top: 4px;
}

.dialog-button {
  margin-top: 6px;
}

.dialog-pagination {
  margin-top: 20px;
  margin-bottom: 20px;
  float: right;
}

.platform {
  margin: 20px 20px;

  .el-radio {
    padding: 10px 10px;
  }
}

/deep/.hide-content {
  display: none !important;
}

//删除全页面按钮边框
// .el-button {
//   border: none;
// }
// 按钮
.btn-list {
  margin-bottom: 22px;
  display: flex;
  justify-content: space-between;

  .item {
    // flex: 1;

    &:last-child {
      text-align: right;

      .el-button {
        width: 120px;

        // color: #2d7edf;
        // border: 1px solid #2d7edf;
        &:last-child,
        .goods-export {
          color: #ffffff;
          // border: 1px solid #409eff;
        }
      }

      .el-button--warning {
        background-color: #ff9226;
      }

      .goods-export {
        color: #ffffff;
        // border: 1px solid #409eff;
      }
    }

    .el-button {
      height: 36px;
      line-height: 36px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .is-disabled {
      background-color: #f4f4f5 !important;
      border: 1px solid #d3d4d6 !important;
      color: #909399 !important;
    }

    /deep/ .el-radio-button__inner {
      padding: 8px 20px;
    }
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/.el-scrollbar {
  height: 10px;
}

/deep/.el-scrollbar__bar.is-horizontal {
  height: 9px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}
</style>
